module.exports = __webpack_public_path__ + "801d623e42e583ef8260f811095b3872.svg";